const updates = [
  { date: '2026.07.28', title: '51cg官方域名更新通告', summary: '最新可用域名已通过官方渠道确认，访问状态正常，建议用户及时更新收藏夹中的入口地址。', type: '域名' },
  { date: '2026.07.25', title: '平台内容板块调整说明', summary: '51cg对部分内容分区进行了优化重组，新增专题聚合页面，提升了内容发现效率。', type: '平台' },
  { date: '2026.07.22', title: '移动端访问体验升级', summary: '51cg移动端页面完成新一轮适配优化，加载速度提升明显，交互体验更加流畅。', type: '功能' },
  { date: '2026.07.18', title: '安全访问提醒：注意仿冒站点', summary: '近期发现多起仿冒51cg的钓鱼站点，请认准本导航站收录的官方域名，避免信息泄露。', type: '安全' },
  { date: '2026.07.15', title: '社区功能更新：新增互动模块', summary: '平台上线了全新的社区互动功能，用户参与度和内容产出量均有显著提升。', type: '功能' },
  { date: '2026.07.10', title: '51cg.fun 域名状态确认', summary: '51cg.fun域名当前访问正常，已通过多重验证确认其为官方可用入口之一。', type: '域名' },
  { date: '2026.07.05', title: '内容审核机制优化说明', summary: '平台更新了内容审核流程，在保证内容质量的同时提升了发布时效性。', type: '平台' },
  { date: '2026.07.01', title: '季度访问数据与入口汇总', summary: '本季度51cg各域名入口均保持稳定，访问成功率维持在较高水平，导航站同步更新。', type: '汇总' },
];

export default function UpdateSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">动态快讯</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">实时追踪51cg最新域名变更、平台动态与安全提醒</p>
        </div>

        <div className="relative max-w-3xl mx-auto">
          <div className="absolute left-4 md:left-5 top-3 bottom-3 w-px bg-background-200"></div>
          <div className="space-y-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 md:gap-6 pl-10 md:pl-12">
                <div className="absolute left-[13px] md:left-[16px] top-1.5 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-primary-50 text-primary-600 font-medium whitespace-nowrap">
                      {item.type}
                    </span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}